export default "__VITE_ASSET__0eHuvogG__"